<template>
  <v-card>
    <v-card-title>タブ名設定フォーム</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="8">
            <v-text-field
              label="ヘッダ名"
              v-model="returnData.label"
              required
              hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-text-field
              label="{フォーム}IDまたはテキスト"
              v-model="returnData.init"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rule0"
              label="サブページの値を表示"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="3" v-if="rule0 == 'true'">
            <v-text-field
              v-model="rules[0]"
              label="サブページのフォームID"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <!-------------------------------------->
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    type: Number,
    cols: Number,
    position: Number,
    //個別値
    value: String,
    rule: String,
    init: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: this.rule,
        init: this.init,
      },
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      //個別値
      rule0: "",
      rules: [""],
      items1: [
        { label: "何も表示しない", value: "" },
        { label: "テキスト入力", value: "inputText" },
        { label: "数値入力", value: "inputNumber" },
      ],
    };
  },
  mounted() {
    if (typeof this.rule != "undefined") {
      this.rules = this.rule.split(",");
    }

    if (this.rules[0] != "") {
      this.rule0 = "true";
    }
  },
  methods: {
    submit() {
      if (this.rule0 != "true") {
        this.rules[0] = "";
      }
      this.returnData.rule = this.rules.join(",");
      //
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
